import { EboObject } from '../base-classes/ebo-object';
import { Hub } from '../places/hub/hub';
import { Employee } from './employee';

export class EmployeeHub extends EboObject {
  hubID: number;
  hub: Hub;
  employeeID: string;
  employee: Employee;

  constructor(jsonData: Partial<EmployeeHub>) {
    super(jsonData);
    if (jsonData.hub) this.hub = new Hub(jsonData.hub);
    if (jsonData.employee) this.employee = new Employee(jsonData.employee);
  }

  toShortString(format: string): string {
    if (format == 'hubToShortString') {
      return this.hub ? this.hub.toShortString() : null;
    }
    return null;
  }
}
